import React from 'react';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircleSharp';
import CancelIcon from '@mui/icons-material/CancelSharp';
import { useTranslation } from 'src/i18n';
import './CommissioningStatusIcon.scss';

const configs = {
  pass: {
    icon: CheckCircleIcon,
    labelKey: 'common.pass',
  },
  'pass-with-notes': {
    icon: CheckCircleIcon,
    labelKey: 'common.passWithNotes',
  },
  failed: {
    icon: CancelIcon,
    labelKey: 'common.failed',
  },
};

export default function CommissioningStatusIcon ({ status }) {
  const { t } = useTranslation();

  const cfg = configs[status];
  if (!cfg) return <span>—</span>;

  const Icon = cfg.icon;

  return (
    <span className={`commissioning-status-pill commissioning-status-${status}`}>
      <Icon className='commissioning-status-icon' />
      {t(cfg.labelKey)}
    </span>
  );
}

CommissioningStatusIcon.propTypes = {
  status: PropTypes.string,
};

CommissioningStatusIcon.defaultProps = {
  status: null,
};
